import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getUsuarioListSuccess(usuario) {
  return {type: types.LOAD_USUARIO_LIST_SUCCESS, usuario};
}



export function getUsuarioList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().UsuarioApi.getUsuarioList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(usuario => {                  
                  dispatch(getUsuarioListSuccess(usuario));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getUsuarioSuccess(catalogo) {
  return {type: types.LOAD_USUARIO_SUCCESS, catalogo};
}

export function getUsuario(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().UsuarioApi.getUsuario(id, token).then(usuario => {   
        dispatch(getUsuarioSuccess(usuario));
        return usuario;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function getUsuarioBusqueda(cadena,cursoId,token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().UsuarioApi.getUsuarioBusqueda(cadena, cursoId,token).then(usuario => {   
        dispatch(getUsuarioSuccess(usuario));
        return usuario;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getInfoPerfil(token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().UsuarioApi.getInfoPerfil( token).then(usuario => {   
        dispatch(getUsuarioSuccess(usuario));
        return usuario;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveSuccess(usuario) {
  return {type: types.SAVE_USUARIO_SUCCESS, usuario};
}


export function save(usuario, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().UsuarioApi.save(usuario, token).then(usuarioGuardado => {   
    dispatch(saveSuccess(usuarioGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getUsuarioComboSuccess(datos) {
  return {type: types.GET_USUARIOS_COMBO_SUCCESS, datos};
}

export function getUsuarioCombo(tipo, token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().UsuarioApi.getUsuarioCombo(tipo,token).then(datos => {   
      dispatch(getUsuarioComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(usuario) {
  return {type: types.BORRAR_USUARIO_SUCCESS, usuario};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().UsuarioApi.borrar(id, token ).then(usuario => {
               
                  dispatch(borrarSuccess(usuario));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(usuario) {
  return {type: types.ACTIVAR_USUARIO_SUCCESS, usuario};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().UsuarioApi.activar(id, token).then(usuario => {
               
                  dispatch(activarSuccess(usuario));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_USUARIO, filtro};
}

export function saveAdjuntoSuccess() {
  return {type: types.SAVE_DOCUMENTO_ADJUNTO_SUCCESS};
}



export function saveAdjunto(datos, token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().UsuarioApi.saveAdjunto(datos, token).then((foto) => {            
        dispatch(getFotoPerfilSuccess(foto.descripcion));   
             
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveAdjuntoProfesor(datos, token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().UsuarioApi.saveAdjuntoProfesor(datos, token).then((foto) => {            
        dispatch(getFotoPerfilSuccess(foto.descripcion));   
         return foto;    
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getFotoPerfilSuccess(datos) {
  return {type: types.SET_FOTO_PERFIL_SUCCESS,datos};
}



export function getFotoPerfil( token) {
  return dispatch => {
	dispatch(beginAjaxCall());  
        return Api().UsuarioApi.getFotoPerfil(token).then((foto) => {            
        dispatch(getFotoPerfilSuccess(foto.descripcion ));   
             
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

